import { render, staticRenderFns } from "./BillingChargeStats.vue?vue&type=template&id=5837d90c"
import script from "./BillingChargeStats.vue?vue&type=script&lang=js"
export * from "./BillingChargeStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports